import { ActivityInfo } from './ActivityInfo.main';
import { AdditionalInfo } from './AdditionalInfo.main';
import { BranchesInfo } from './BranchesInfo.main';
import { PersonalInfo } from './PersonalInfo.main';

export { PersonalInfo, ActivityInfo, BranchesInfo, AdditionalInfo };
